import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Statistic } from 'semantic-ui-react';
import ThemeColorSetting from '../../../constants/themeColor';
import checkersGraph from '../../../assets/pattern/tiny-checkers.svg';

const styles = {
  container : {
    backgroundColor : ThemeColorSetting.black,
    padding : '5vh 0vh',
    backgroundImage: 'url(' +checkersGraph+ ')',
		backgroundSize : '25px 25px',
		backgroundRepeat : 'repeat'
  },
  statContainer : {
    display : 'flex',
    flexDirection : 'row',
    justifyContent : 'center',
    alignItems : 'center'
  },
  header : {
    color : ThemeColorSetting.white,
    fontSize : '50px',
  },
  unitCount : {
    color : ThemeColorSetting.white,
    fontSize : '30px'
  }
}

class CaseFooter extends Component {
  render() {
    const { string } = this.props;
    return(
      <Grid.Row style={styles.container}>
        <Grid.Column style={styles.statContainer}>
          <Statistic horizontal>
            <Statistic.Value style={styles.header}>165,156</Statistic.Value>
            <Statistic.Label style={styles.unitCount}>{string['caseFooter']}</Statistic.Label>
          </Statistic>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(CaseFooter)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/case/caseFooter.js
 **/